import { useQuery } from 'react-query';

import { Event } from '../../../types/Event';
import Api from '../../api/api';

export const getEventById = async (id: string): Promise<Event> => {
  const [response, bodyOrError] = await Api.get(`events/${id}`);

  if (!response.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

export const useGetEventById = (id: string) => {
  return useQuery(['getEventById', id], () => getEventById(id), {
    enabled: !!id,
  });
};
